import { captureMessage, captureException } from '@sentry/react';
import { loadScript } from '@/utils';
import { styles } from './mapStyles';

interface MapPosition {
  lat: number;
  lng: number;
}

interface ContactsMapOptions {
  apiKey: string;
  markerIcon: string;
  markerPosition: MapPosition;
}

const initContactsMap = (lang: string, options: ContactsMapOptions, delay?: number): void => {
  const {
    apiKey,
    markerIcon,
    markerPosition
  } = options;

  (window as Window & {
    onMapLoaded?: () => void
  }).onMapLoaded = () => {
    const mapContainer = document.getElementById('map');

    if (!mapContainer) {
      captureMessage('initContactsMap: element #map not found', { level: 'warning' });
      return;
    }

    try {
      const map = new google.maps.Map(mapContainer, {
        zoom: 10,
        center: markerPosition,
        scrollwheel: false,
        styles,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true
      });

       
      new google.maps.Marker({
        position: markerPosition,
        map,
        icon: {
          url: markerIcon,
          size: new google.maps.Size(28, 50),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(14, 50)
        }
      });
    } catch (e) {
      captureException(e, { extra: { context: 'google_maps_init', markerPosition } });
    }
  };

  const url = `//maps.googleapis.com/maps/api/js?key=${apiKey}&language=${lang}&callback=onMapLoaded`;

  if (delay) {
    setTimeout(() => loadScript('googleMap', url), delay);
  } else {
    loadScript('googleMap', url);
  }
};

export default initContactsMap;
